import type { HTMLAttributes, ReactNode } from 'react';

export interface KindGlyphProps extends HTMLAttributes<HTMLSpanElement> {
  /** Short mono label or icon — e.g. `TSK`, `DOC`. */
  children: ReactNode;
}

/**
 * 28px bordered square glyph box — the kind marker on dashboard pending-work
 * and recent-document rows. Matches the `.pw-kind` / `.doc-icon` box in
 * `!-landing-page/dashboard.html`.
 */
export function KindGlyph({ children, className, ...rest }: KindGlyphProps) {
  const cls = ['pn-kind-glyph', className].filter(Boolean).join(' ');
  return (
    <span className={cls} aria-hidden {...rest}>
      {children}
    </span>
  );
}
